<template>
  <footer v-show="isVisible">
    <div class="container">
      <div class="row">
        <div class="row-inc">
          <div class="top">
            <Logo/>
            <div class="licence-footer">
              <SocialMedia/>
            </div>
          </div>
          <div class="center">
            <div class="row">
              <div class="col items" v-if="!isMobile">
                <h1>Spor</h1>
                <ul>
                  <li><router-link :to="{ name: 'Sportsbook'}"> Spor Bahisleri</router-link></li>
                  <li><router-link :to="{ name: 'Live'}"> Canlı Bahis</router-link></li>
                  <li><router-link :to="{ name: 'Virtual'}"> Sanal Bahis</router-link></li>
                </ul>
              </div>
              <div class="col items" v-if="!isMobile">
                <h1>Casino</h1>
                <ul>
                  <li><router-link :to="{ name: 'Slot'}"> Casino</router-link></li>
                  <li><router-link :to="{ name: 'Casino'}"> Canlı Casino</router-link></li>
                </ul>
              </div>
              <div class="col items" v-if="!isMobile">
                <h1>Sanal</h1>
                <ul>
                  <li><router-link :to="{ name: 'Sportsbook'}"> Mobil Oyunlar</router-link></li>
                  <li><router-link :to="{ name: 'Live'}"> E-Sporlar</router-link></li>
                </ul>
              </div>
              <div class="col items" v-if="!isMobile">
                <h1>Masa Oyunları</h1>
                <ul>
                  <li><router-link :to="{ name: 'Betongames'}"> Poker</router-link></li>
                  <li><router-link :to="{ name: 'Bingo'}"> Tombala</router-link></li>
                  <li><router-link :to="{ name: 'Bingo'}"> TV Games</router-link></li>
                </ul>
              </div>
              <div class="col items">
                <h1>Yardım</h1>
                <ul>
                  <li v-for="(item, key) in pages" :key="key"><router-link :to="{ name: 'Page', params:{slug: item.url} }">{{ item.title }}</router-link></li>
                </ul>
              </div>
              <div class="col items">
                <h1>İletişim</h1>
                <ul>
                  <li><a href="javascript:;">destek@{{ _.lowerCase($store.getters['getClientMeta'].name).split(' ').join('') }}.com</a></li>
                  <li><a href="javascript:;">marketing@{{ _.lowerCase($store.getters['getClientMeta'].name).split(' ').join('') }}.com</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="licence-area">
            <a target="_blank" href="https://cert.gcb.cw/certificate?id=ZXlKcGRpSTZJbmRLZWtsTlZHdHVjMGhzZVZGdmVrNU5UV0ZpUWxFOVBTSXNJblpoYkhWbElqb2lSVVo0VWprMlVUTmtiRmRFVUVOSk5FdFNUWGMyWnowOUlpd2liV0ZqSWpvaVptVXpPV1JrTWprM1ltVmhNamRoWVRJNE56azJZemswTkRFd01qVTVPRFEyTWpSaU5XSTRaVGc1TTJFNE56STRPR0psT0dGa00yWXhaRFV3WVRNMll5SXNJblJoWnlJNklpSjk=">
              <img src="https://seal.cgcb.info/8b089e55-4795-425a-6bf6-fdb75eba6900" width="88" height="50">
            </a>
            <div class="title">
              <svg width="800px" height="800px" viewBox="0 0 256 256" id="Flat"> <path d="M116,132.00012v-52a12,12,0,1,1,24,0v52a12,12,0,1,1-24,0ZM236,91.54944V164.4508a19.87049,19.87049,0,0,1-5.85645,14.14112l-51.55078,51.55029a19.86559,19.86559,0,0,1-14.1416,5.85791H91.54883a19.86641,19.86641,0,0,1-14.14258-5.85889L25.85742,178.59289A19.87129,19.87129,0,0,1,20,164.4508V91.54944a19.87242,19.87242,0,0,1,5.85645-14.1416L77.40723,25.858a19.86559,19.86559,0,0,1,14.1416-5.85791h72.90234a19.868,19.868,0,0,1,14.14258,5.8584l51.54883,51.54834A19.87327,19.87327,0,0,1,236,91.54944Zm-24,1.65625L162.794,44.00012H93.20605L44,93.20569v69.58886l49.20605,49.20557H162.794L212,162.79455Zm-84,62.79443a16,16,0,1,0,16,16A16.018,16.018,0,0,0,128,156.00012Z"/> </svg>
              LİSANSSIZ SİTELERDEN UZAK DURUN
              <svg width="800px" height="800px" viewBox="0 0 256 256" id="Flat"> <path d="M116,132.00012v-52a12,12,0,1,1,24,0v52a12,12,0,1,1-24,0ZM236,91.54944V164.4508a19.87049,19.87049,0,0,1-5.85645,14.14112l-51.55078,51.55029a19.86559,19.86559,0,0,1-14.1416,5.85791H91.54883a19.86641,19.86641,0,0,1-14.14258-5.85889L25.85742,178.59289A19.87129,19.87129,0,0,1,20,164.4508V91.54944a19.87242,19.87242,0,0,1,5.85645-14.1416L77.40723,25.858a19.86559,19.86559,0,0,1,14.1416-5.85791h72.90234a19.868,19.868,0,0,1,14.14258,5.8584l51.54883,51.54834A19.87327,19.87327,0,0,1,236,91.54944Zm-24,1.65625L162.794,44.00012H93.20605L44,93.20569v69.58886l49.20605,49.20557H162.794L212,162.79455Zm-84,62.79443a16,16,0,1,0,16,16A16.018,16.018,0,0,0,128,156.00012Z"/> </svg>
            </div>
            <p>Üst alanda CGB Lisansına tıklayarak Mersobahis lisansını görebilirsiniz.</p>
          </div>
          <div style="text-align: center;">
            {{ $store.getters['getClientMeta'].name }} is operated by Joker Marketing B.V., a company incorporated under the laws of Curaçao with Company Number 161448 and has a valid Certificate of Operation. This Certificate of Operation is subject to the National Ordinance on Offshore Games of Hazard (Landsverordening buitengaatse hazardspelen, P.B. 1993, no. 63) (NOOGH)
              The RGA and GT&C contain important limitations and restrictions that are imposed for your protection and those of others. Before you decide to participate in any game, please make sure to carefully review the RGA and GT&C and regularly check for changes. Either by accessing, registering, or using the gaming environment, you signify to acknowledge, agree and accept the RGA and GT&C, and to be legally bound by it.
              The official version of the RGA and GT&C is written in the English language, which supersedes all translations. Any modifications or updates will replace previous versions and become effective two weeks after being made available on the website. It is the user’s responsibility to regularly check for changes. By continuing to use the services after the updated terms become effective, the user is considered to have accepted the changes. Existing users may choose to discontinue using the products and services before the said update becomes effective
          </div><br>
          <img v-if="!isMobile"  src="@/assets/images/partners.png" style="width: 100%;max-width: 100%;margin:15px auto">
          <img v-if="isMobile" src="@/assets/images/mobile-partners.png" style="width: 100%;max-width: 100%;margin:15px auto">
          <img v-if="!isMobile" src="@/assets/images/providers.png" style="width: 100%;max-width: 100%;margin:15px auto">
          <img v-if="isMobile" src="@/assets/images/mobile-providers.png" style="width: 100%;max-width: 100%;margin:15px auto">
          <div class="licence">
            <!-- <img src="@/assets/images/common/licence.png" width="40"> -->
            <div class="age">
              +18 
            </div>
            <span>
              Avrupa’da kurulan ve kısa sürede bahis dünyasında kendine yer bulan {{ $store.getters['getClientMeta'].name }} bahis sitesi, kaliteli hizmetlerini etkin bir ekiple sizlerle paylaşmaya devam ediyor. Tüm dünyanın güvendiği {{ $store.getters['getClientMeta'].name }} kullanışlı ve etkili tasarımı ile size benzersiz hizmetler sunduğunu ve hem eğlenip hem de para kazandığınızı belirtmek isteriz.
            </span>
          </div>
          <p class="copyright" style="margin-top: 0px; margin-bottom: 30px;">© 2022 {{ $store.getters['getClientMeta'].name }} Tüm hakları saklıdır.</p>
        </div>
      </div>
    </div>
  </footer>
</template>
<style lang="scss">
  .licence-footer{
    display: flex;
  }
  #app.mobile .licence-footer{
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 10px 0;
    .licence-button{
      text-align: center;
    }
  }
</style>
<script>
	import Logo from './Header/Logo'
	import SocialMedia from './SocialMedia'
  export default{
    data(){
      return{
      }
    },
    computed:{
      providers(){
        return this.$store.getters['special/footerProviders'];
      },
      social(){
        return this.$store.getters.getClientContent;
      },
      pages() {
        return this.$store.getters.getClientPages;
      },
      lang(){
        return this.$store.getters.getLanguages;
      },
      isVisible(){
        if(this.$route.name == 'Homepage' && this.isMobile || !this.isMobile){
          return true;
        }else{
          return false;
        }
      }
    },
    methods:{
      upTop(){
        window.scrollTo(0,0);
      }
    },
		components:{
      Logo,
			SocialMedia
		}
  }
</script>